import React from 'react';

const TextTR = ({ title, show = true, children }) =>
  show ? (
    <tr>
      <td style={{ paddingRight: '20px' }}>{title}:</td>
      <td>{children}</td>
    </tr>
  ) : null;

export default TextTR;
